// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ownership {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  min-width: 328px;
}

.ownership .ownership-header {
  width: 100%;
  border-bottom: 1px solid var(--border-line);
  padding-bottom: 10px;
  margin-bottom: 10px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  line-height: 100%;
  color: var(--text-primary);
}

.ownership .ownership-table {
  margin-top: 24px;
  min-width: 328px;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
}

.ownership .ownership-table thead th {
  box-sizing: border-box;
  white-space: nowrap;
  height: 32px;
  border-bottom: 1px solid var(--border-line);
  vertical-align: bottom;
  padding-bottom: 8px;

  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--text-subheader);

  text-align: left;

  .long_num {
    display: inline;
  }

  .short_num {
    display: none;
  }

  &:first-child {
    padding-left: 16px;
  }

  &:nth-child(2),
  &:nth-child(3),
  &:last-child {
    text-align: right;
  }

  &:last-child {
    padding-right: 10px;
    padding-left: 16px;
    width: 110px;
  }
}

.ownership .ownership-table tbody tr {
  &:nth-child(2n) {
    background-color: var(--row-dark);
  }
}

.ownership .ownership-table tbody td {
  padding: 8px 0px;
  font-size: 16px;
  height: 40px;
  box-sizing: border-box;
  white-space: nowrap;

  &:first-child {
    padding-left: 16px;
  }

  &:last-child {
    padding-right: 10px;
    padding-left: 16px;
    color: var(--text-secondary);
    text-align: right;
  }
}

.ownership .ownership-table thead th:first-child,
.ownership .ownership-table tbody td:first-child {
  width: 100%;
  max-width: 0;
}

.ownership .info {
  display: flex;
  gap: 8px;
  height: 100%;
  min-width: 0;
  align-items: center;
}

.ownership .table-flex-column {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  text-align: left;
}

.ownership .index {
  display: block;
  min-width: 0;
  max-width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
  user-select: none;
  -webkit-user-select: none;
}

.ownership .name {
  height: 14px;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;

  color: var(--text-primary);
}

.ownership .ownership-table tbody td img {
  margin: 0px;
  padding: 0px;
  height: 34px;
}

.ownership .number-of-shares {
  display: flex;
  text-align: right;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
}

.ownership .number-of-shares > .sharesheld {
  margin-right: 4px;
  flex: 0.7;
}

.ownership .number-of-shares > .pctoutstanding {
  flex: 0.3;
}

.ownership .shareschg {
  display: flex;
  justify-content: flex-end;
  text-align: right;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--text-primary);
}

.ownership .shareschg > .nc {
  flex: 1;
}

.ownership .shareschg > .pc {
  flex: 1;
}

.ownership .shareschg > .new {
  flex: 1;
  font-weight: bold;
  color: var(--color-brand);
}

.ownership .up {
  color: var(--text-up-color);
}

.ownership .down {
  color: var(--text-down-color);
}

.ownership .ownership-summary {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
}

.ownership .ownership-summary-item {
  background-color: var(--surface-tertiary);

  /* border-box: để flex chia đều theo width ngoài, không bị lệch
     do padding-left/right riêng của .mktcap và .freefloat */
  box-sizing: border-box;
  flex: 1 1 0;
  min-width: auto;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 65px;
  padding: 10px;
}

.ownership .ownership-summary-item-title {
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-label);
}

.ownership .ownership-summary-item-short-value {
  display: none;
  white-space: nowrap;
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
  line-height: 100%;
  color: var(--text-primary);
}

.ownership .ownership-summary-item-value {
  margin-top: 10px;
  font-size: 20px;
  font-weight: bold;
  line-height: 100%;
  color: var(--text-primary);
}

.ownership .ownership-summary-item-value .currency,
.ownership .ownership-summary-item-short-value .currency,
.ownership .ownership-summary-item-short-value .unit {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  color: var(--text-primary);
}

@container (min-width: 768px) and (max-width: 1199px) {
  .ownership .number-of-shares {
    text-align: center;
    padding-right: 20px;
  }
}

@container (max-width: 767px) {
  .ownership .number-of-shares > .sharesheld {
    flex: 0.6;
  }

  .ownership .number-of-shares > .pctoutstanding {
    flex: 0.4;
  }

  .ownership .ownership-table thead th .long_num {
    display: none;
  }

  .ownership .ownership-table thead th .short_num {
    display: inline;
  }

  .ownership .ownership-table thead th {
    &:nth-child(2) {
      padding-right: 20px;
    }

    &:nth-child(3),
    &:last-child {
      display: none;
    }
  }

  .ownership .ownership-table tbody td {
    &:nth-child(2) {
      padding-right: 10px;
    }

    &:nth-child(3),
    &:last-child {
      display: none;
    }
  }

  .ownership .ownership-summary-item-value {
    display: none;
  }

  .ownership .ownership-summary-item-short-value {
    display: block;
  }

  .ownership .ownership-table thead th:first-child,
  .ownership .ownership-table tbody td:first-child {
    padding-left: 24px;
  }
  .ownership .ownership-table thead th:nth-child(2),
  .ownership .ownership-table tbody td:nth-child(2) {
    padding-right: 24px;
  }
  .ownership .ownership-summary-item.mktcap {
    padding-left: 24px;
  }
  .ownership .ownership-summary-item.freefloat {
    padding-right: 24px;
  }
}

@container (max-width: 450px) {
  .ownership .number-of-shares > .sharesheld {
    margin-right: 20px;
    flex: 1;
  }

  .ownership .number-of-shares > .pctoutstanding {
    flex: 1;
    padding-right: 15px;
  }
}

@container (max-width: 420px) {
  .ownership .ownership-table thead th {
    white-space: normal;
    font-size: 14px;
    line-height: 18px;
  }

  .ownership .ownership-table tbody td {
    font-size: 14px;
  }

  .ownership .number-of-shares,
  .ownership .shareschg {
    font-size: 14px;
  }

  .ownership .number-of-shares > .sharesheld {
    margin-right: 8px;
  }

  .ownership .number-of-shares > .pctoutstanding {
    padding-right: 0;
  }

  .ownership .ownership-table thead th:first-child,
  .ownership .ownership-table tbody td:first-child {
    padding-left: 12px;
  }

  .ownership .ownership-table thead th:nth-child(2),
  .ownership .ownership-table tbody td:nth-child(2) {
    padding-right: 12px;
  }

  .ownership .ownership-summary-item.mktcap {
    padding-left: 12px;
  }

  .ownership .ownership-summary-item.freefloat {
    padding-right: 12px;
  }
}

.ownership-table-spacer {
  height: 8px;
}
@container (min-width: 768px) {
  .ownership .ownership-table thead th:first-child,
  .ownership .ownership-table tbody td:first-child {
    padding-left: 32px;
  }
  .ownership .ownership-table thead th:last-child,
  .ownership .ownership-table tbody td:last-child {
    padding-right: 32px;
  }
  .ownership .ownership-summary-item.mktcap {
    padding-left: 32px;
  }
  .ownership .ownership-summary-item.freefloat {
    padding-right: 32px;
  }

  /* Proportional column widths so the name column stops stretching on wide
     containers and the numeric columns share the freed space. */
  .ownership .ownership-table {
    table-layout: fixed;
  }
  .ownership .ownership-table thead th:first-child,
  .ownership .ownership-table tbody td:first-child {
    width: 32%;
    max-width: none;
  }
  .ownership .ownership-table thead th:nth-child(2),
  .ownership .ownership-table tbody td:nth-child(2) {
    width: 23%;
  }
  .ownership .ownership-table thead th:nth-child(3),
  .ownership .ownership-table tbody td:nth-child(3) {
    width: 25%;
  }
  .ownership .ownership-table thead th:last-child,
  .ownership .ownership-table tbody td:last-child {
    width: 20%;
  }

  /* Keep the shares/change values right-aligned across all desktop widths. */
  .ownership .number-of-shares {
    text-align: right;
    padding-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/OwnershipWidget/OwnershipWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,sBAAsB;EACtB,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;;EAE5B,gBAAgB;;EAEhB;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;EACnB;AACF;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;;EAEZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;;EAEvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,yCAAyC;;EAEzC;4DAC0D;EAC1D,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;;MAEE,aAAa;IACf;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;;MAEE,aAAa;IACf;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,OAAO;EACT;;EAEA;IACE,OAAO;IACP,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;AACb;AACA;EACE;;IAEE,kBAAkB;EACpB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;;EAEA;gEAC8D;EAC9D;IACE,mBAAmB;EACrB;EACA;;IAEE,UAAU;IACV,eAAe;EACjB;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;EACA;;IAEE,UAAU;EACZ;;EAEA,2EAA2E;EAC3E;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".ownership {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  min-width: 328px;\n}\n\n.ownership .ownership-header {\n  width: 100%;\n  border-bottom: 1px solid var(--border-line);\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n.ownership .ownership-table {\n  margin-top: 24px;\n  min-width: 328px;\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0px;\n}\n\n.ownership .ownership-table thead th {\n  box-sizing: border-box;\n  white-space: nowrap;\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n  vertical-align: bottom;\n  padding-bottom: 8px;\n\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  color: var(--text-subheader);\n\n  text-align: left;\n\n  .long_num {\n    display: inline;\n  }\n\n  .short_num {\n    display: none;\n  }\n\n  &:first-child {\n    padding-left: 16px;\n  }\n\n  &:nth-child(2),\n  &:nth-child(3),\n  &:last-child {\n    text-align: right;\n  }\n\n  &:last-child {\n    padding-right: 10px;\n    padding-left: 16px;\n    width: 110px;\n  }\n}\n\n.ownership .ownership-table tbody tr {\n  &:nth-child(2n) {\n    background-color: var(--row-dark);\n  }\n}\n\n.ownership .ownership-table tbody td {\n  padding: 8px 0px;\n  font-size: 16px;\n  height: 40px;\n  box-sizing: border-box;\n  white-space: nowrap;\n\n  &:first-child {\n    padding-left: 16px;\n  }\n\n  &:last-child {\n    padding-right: 10px;\n    padding-left: 16px;\n    color: var(--text-secondary);\n    text-align: right;\n  }\n}\n\n.ownership .ownership-table thead th:first-child,\n.ownership .ownership-table tbody td:first-child {\n  width: 100%;\n  max-width: 0;\n}\n\n.ownership .info {\n  display: flex;\n  gap: 8px;\n  height: 100%;\n  min-width: 0;\n  align-items: center;\n}\n\n.ownership .table-flex-column {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n\n  text-align: left;\n}\n\n.ownership .index {\n  display: block;\n  min-width: 0;\n  max-width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.ownership .name {\n  height: 14px;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n\n  color: var(--text-primary);\n}\n\n.ownership .ownership-table tbody td img {\n  margin: 0px;\n  padding: 0px;\n  height: 34px;\n}\n\n.ownership .number-of-shares {\n  display: flex;\n  text-align: right;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.ownership .number-of-shares > .sharesheld {\n  margin-right: 4px;\n  flex: 0.7;\n}\n\n.ownership .number-of-shares > .pctoutstanding {\n  flex: 0.3;\n}\n\n.ownership .shareschg {\n  display: flex;\n  justify-content: flex-end;\n  text-align: right;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n.ownership .shareschg > .nc {\n  flex: 1;\n}\n\n.ownership .shareschg > .pc {\n  flex: 1;\n}\n\n.ownership .shareschg > .new {\n  flex: 1;\n  font-weight: bold;\n  color: var(--color-brand);\n}\n\n.ownership .up {\n  color: var(--text-up-color);\n}\n\n.ownership .down {\n  color: var(--text-down-color);\n}\n\n.ownership .ownership-summary {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.ownership .ownership-summary-item {\n  background-color: var(--surface-tertiary);\n\n  /* border-box: để flex chia đều theo width ngoài, không bị lệch\n     do padding-left/right riêng của .mktcap và .freefloat */\n  box-sizing: border-box;\n  flex: 1 1 0;\n  min-width: auto;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 65px;\n  padding: 10px;\n}\n\n.ownership .ownership-summary-item-title {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-label);\n}\n\n.ownership .ownership-summary-item-short-value {\n  display: none;\n  white-space: nowrap;\n  margin-top: 10px;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n.ownership .ownership-summary-item-value {\n  margin-top: 10px;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n.ownership .ownership-summary-item-value .currency,\n.ownership .ownership-summary-item-short-value .currency,\n.ownership .ownership-summary-item-short-value .unit {\n  margin-top: 10px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 100%;\n  color: var(--text-primary);\n}\n\n@container (min-width: 768px) and (max-width: 1199px) {\n  .ownership .number-of-shares {\n    text-align: center;\n    padding-right: 20px;\n  }\n}\n\n@container (max-width: 767px) {\n  .ownership .number-of-shares > .sharesheld {\n    flex: 0.6;\n  }\n\n  .ownership .number-of-shares > .pctoutstanding {\n    flex: 0.4;\n  }\n\n  .ownership .ownership-table thead th .long_num {\n    display: none;\n  }\n\n  .ownership .ownership-table thead th .short_num {\n    display: inline;\n  }\n\n  .ownership .ownership-table thead th {\n    &:nth-child(2) {\n      padding-right: 20px;\n    }\n\n    &:nth-child(3),\n    &:last-child {\n      display: none;\n    }\n  }\n\n  .ownership .ownership-table tbody td {\n    &:nth-child(2) {\n      padding-right: 10px;\n    }\n\n    &:nth-child(3),\n    &:last-child {\n      display: none;\n    }\n  }\n\n  .ownership .ownership-summary-item-value {\n    display: none;\n  }\n\n  .ownership .ownership-summary-item-short-value {\n    display: block;\n  }\n\n  .ownership .ownership-table thead th:first-child,\n  .ownership .ownership-table tbody td:first-child {\n    padding-left: 24px;\n  }\n  .ownership .ownership-table thead th:nth-child(2),\n  .ownership .ownership-table tbody td:nth-child(2) {\n    padding-right: 24px;\n  }\n  .ownership .ownership-summary-item.mktcap {\n    padding-left: 24px;\n  }\n  .ownership .ownership-summary-item.freefloat {\n    padding-right: 24px;\n  }\n}\n\n@container (max-width: 450px) {\n  .ownership .number-of-shares > .sharesheld {\n    margin-right: 20px;\n    flex: 1;\n  }\n\n  .ownership .number-of-shares > .pctoutstanding {\n    flex: 1;\n    padding-right: 15px;\n  }\n}\n\n@container (max-width: 420px) {\n  .ownership .ownership-table thead th {\n    white-space: normal;\n    font-size: 14px;\n    line-height: 18px;\n  }\n\n  .ownership .ownership-table tbody td {\n    font-size: 14px;\n  }\n\n  .ownership .number-of-shares,\n  .ownership .shareschg {\n    font-size: 14px;\n  }\n\n  .ownership .number-of-shares > .sharesheld {\n    margin-right: 8px;\n  }\n\n  .ownership .number-of-shares > .pctoutstanding {\n    padding-right: 0;\n  }\n\n  .ownership .ownership-table thead th:first-child,\n  .ownership .ownership-table tbody td:first-child {\n    padding-left: 12px;\n  }\n\n  .ownership .ownership-table thead th:nth-child(2),\n  .ownership .ownership-table tbody td:nth-child(2) {\n    padding-right: 12px;\n  }\n\n  .ownership .ownership-summary-item.mktcap {\n    padding-left: 12px;\n  }\n\n  .ownership .ownership-summary-item.freefloat {\n    padding-right: 12px;\n  }\n}\n\n.ownership-table-spacer {\n  height: 8px;\n}\n@container (min-width: 768px) {\n  .ownership .ownership-table thead th:first-child,\n  .ownership .ownership-table tbody td:first-child {\n    padding-left: 32px;\n  }\n  .ownership .ownership-table thead th:last-child,\n  .ownership .ownership-table tbody td:last-child {\n    padding-right: 32px;\n  }\n  .ownership .ownership-summary-item.mktcap {\n    padding-left: 32px;\n  }\n  .ownership .ownership-summary-item.freefloat {\n    padding-right: 32px;\n  }\n\n  /* Proportional column widths so the name column stops stretching on wide\n     containers and the numeric columns share the freed space. */\n  .ownership .ownership-table {\n    table-layout: fixed;\n  }\n  .ownership .ownership-table thead th:first-child,\n  .ownership .ownership-table tbody td:first-child {\n    width: 32%;\n    max-width: none;\n  }\n  .ownership .ownership-table thead th:nth-child(2),\n  .ownership .ownership-table tbody td:nth-child(2) {\n    width: 23%;\n  }\n  .ownership .ownership-table thead th:nth-child(3),\n  .ownership .ownership-table tbody td:nth-child(3) {\n    width: 25%;\n  }\n  .ownership .ownership-table thead th:last-child,\n  .ownership .ownership-table tbody td:last-child {\n    width: 20%;\n  }\n\n  /* Keep the shares/change values right-aligned across all desktop widths. */\n  .ownership .number-of-shares {\n    text-align: right;\n    padding-right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
